/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Settings_Wevesentacodetoemail5Inputs */

const en_settings_wevesentacodetoemail5 = /** @type {(inputs: Settings_Wevesentacodetoemail5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We've sent a code to ${i?.email} Please enter the number below to verify your email.`)
};

/**
* | output |
* | --- |
* | "We've sent a code to {email} Please enter the number below to verify your email." |
*
* @param {Settings_Wevesentacodetoemail5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_wevesentacodetoemail5 = /** @type {((inputs: Settings_Wevesentacodetoemail5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Wevesentacodetoemail5Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_wevesentacodetoemail5(inputs)
});
export { settings_wevesentacodetoemail5 as "settings_weveSentACodeToEmail" }